import {Injectable} from "@angular/core";
import {HttpService} from "@supoui/core/services/http.service";
import {Observable} from "rxjs";
import {SupoInvoice} from "@supoui/shared/model/supo-invoice";
import {SupplierInvoiceFilterRequest} from "@supoui/economy/models/invoice-filter-request";
import {InvoiceFilterResponse} from "@supoui/economy/models/invoice-filter-response";

@Injectable({providedIn: 'root'})
export class SupoPendingInvoicesService {
  constructor(private httpService: HttpService) {
  }

  public getPendingInvoices(caseId: string): Observable<SupoInvoice[]> {
    return this.httpService.get<SupoInvoice[]>(`services/caseeconomy/api/supplier-portal-invoices/case/${caseId}`);
  }

  public getPendingInvoice(invoiceId: number): Observable<SupoInvoice> {
    return this.httpService.get<SupoInvoice>(`services/caseeconomy/api/supplier-portal-invoices/${invoiceId}`);
  }

  getInvoicesFiltered(supplierInvoiceFilterRequest: SupplierInvoiceFilterRequest): Observable<InvoiceFilterResponse> {
    return this.httpService.post<InvoiceFilterResponse>('services/caseeconomy/api/supplier-portal-invoices/request', supplierInvoiceFilterRequest);
  }

  deleteInvoices(ids: number[]): Observable<void> {
    return this.httpService.post<void>('services/caseeconomy/api/supplier-portal-invoices/delete', ids);
  }

  resendInvoices(ids: number[]): Observable<void> {
    return this.httpService.post<void>('services/caseeconomy/api/supplier-portal-invoices/resend', ids);
  }

  amendInvoice(invoiceId: number, invoice: SupoInvoice): Observable<void> {
    return this.httpService.put<void>(`services/caseeconomy/api/supplier-portal-invoices/${invoiceId}/and-resend`, invoice);
  }
}
